import PhoenixDocCard from 'components/base/PhoenixDocCard';
import NewUserForm from 'components/forms/NewUserForm';
import { Col, Row } from 'react-bootstrap';
import egg from 'assets/img/spot-illustrations/egg.png';

const RegisterUser = () => {
  return (
    <div>
      <h2 className="mb-4 lh-sm">Create New Account</h2>
      <PhoenixDocCard className="mb-4">
        <PhoenixDocCard.Header noPreview className="pb-0">
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-2">Join the HVA management team!</h4>
                <p className="mb-0">
                  Creating a new account is important. This system provides
                  access to personal data, so only grant access to those who
                  need it based on their duties. When assigning roles, ensure
                  each user only receives the permissions necessary for their
                  work.
                </p>
                <ul className="pt-2 pb-0">
                  <li>All fields are mandatory</li>
                  <li>Review the information before submitting</li>
                </ul>
              </div>
            </Col>
            <Col xs="auto" className="order-xxl-2">
              <div className="x-6 pt-3">
                <img src={egg} alt="" />
              </div>
            </Col>
          </Row>
        </PhoenixDocCard.Header>
        <PhoenixDocCard.Body>
          <div className="col-md-12">
            <div className="card card-container border border-0">
              <div className="form-group pb-6 align-items-end">
                <NewUserForm />
              </div>
            </div>
          </div>
        </PhoenixDocCard.Body>
      </PhoenixDocCard>
    </div>
  );
};

export default RegisterUser;
